/**
 * This provides an interface to ltanalytics
 */

export default {
    page(category, name, propertyObj, options, callback) {
        if (window.ltanalytics) {
            window.ltanalytics.page(category, name, propertyObj, options, callback);
        }
    },

    track(name, propertyObj, options, callback) {
        if (window.ltanalytics) {
            window.ltanalytics.track(name, propertyObj, options, callback);
        }
    },

    reset() {
        if (window.ltanalytics) {
            window.ltanalytics.reset();
        }
    },

    group(id, traits, options, fn) {
        if (window.ltanalytics) {
            window.ltanalytics.group(id, traits, options, fn);
        }
    },

    alias(to, from, options, fn) {
        if (window.ltanalytics) {
            window.ltanalytics.alias(to, from, options, fn);
        }
    },

    once(event, fn) {
        if (window.ltanalytics) {
            window.ltanalytics.once(event, fn);
        }
    },

    off(event, fn) {
        if (window.ltanalytics) {
            window.ltanalytics.off(event, fn);
        }
    },

    on(event, fn) {
        if (window.ltanalytics) {
            window.ltanalytics.on(event, fn);
        }
    },
};
